import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { filterEngineeringTabsForUser } from './engineeringTabItems';
import '../technical/HeatProfilePage.css';

const readUserGroupsFromStorage = () => {
  try {
    const raw = localStorage.getItem('UserGroup');
    if (raw == null || raw === '') return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

/**
 * Engineering sub-tabs (same visual pattern as TechnicalSubTabs).
 * Tabs are filtered by user group (e.g. coil_configurator), like Technical feature cards.
 */
const EngineeringSubTabs = () => {
  const history = useHistory();
  const location = useLocation();
  const currentPath = location.pathname;
  const userGroup = useMemo(() => readUserGroupsFromStorage(), []);
  const visibleTabs = useMemo(() => filterEngineeringTabsForUser(userGroup), [userGroup]);

  const isActive = (path) => {
    if (path === '/engineering') {
      return currentPath === '/engineering' || currentPath === '/coil-configurator';
    }
    return currentPath === path || currentPath.startsWith(`${path}/`);
  };

  const handleTabClick = (path) => {
    if (path !== currentPath) {
      history.push(path);
    }
  };

  if (!visibleTabs.length) return null;

  return (
    <div className="heat-profile-tabs-container">
      <div className="heat-profile-tabs">
        {visibleTabs.map((item) => (
          <div
            key={item.id}
            className={`heat-profile-tab-item ${isActive(item.path) ? 'active' : ''}`}
            onClick={() => handleTabClick(item.path)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleTabClick(item.path);
              }
            }}
            role="tab"
            tabIndex={0}
            aria-selected={isActive(item.path)}
          >
            {item.icon}
            {item.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EngineeringSubTabs;
